export enum AddArticleToCollectionMode {
  SINGLE,
  MULTIPLE
}
